
import React from "react";
import styled from "styled-components";

import AccountingAccountSummary from "./AccountingAccountSummary";
import { getAccountingSourcePresentation } from "./accountingEntryPresentation";

export default function AccountingSourceCard({
  item,
  formatAmount,
}) {
  const sourcePresentation = getAccountingSourcePresentation(
    item?.sourceType
  );

  const entries = Array.isArray(item?.entries)
    ? item.entries
    : [];

  const firstEntry = entries[0] || null;

  return (
    <Card>
      <TopLine>
        <div>
          <Title>
            {sourcePresentation.title}
            <SourceBadge>
              {sourcePresentation.badge}
            </SourceBadge>
          </Title>

          <Description>
            {firstEntry?.description ||
              "Pièce comptable sans description"}
          </Description>
        </div>

        <AmountBadge>
          {entries.length} écriture(s)
        </AmountBadge>
      </TopLine>

      <AccountingAccountSummary
        summary={item?.summary}
        formatAmount={formatAmount}
      />

      <Meta>
        <span>
          Date :{" "}
          {firstEntry?.date
            ? new Date(firstEntry.date).toLocaleString("fr-FR")
            : "—"}
        </span>

        <span>
          Source : {item?.sourceType || "—"}
        </span>

        <span>
          Source UUID : {item?.sourceUuid || "—"}
        </span>

        {item?.compatibilityMode && (
          <span>
            Compatibilité historique : receipt_uuid
          </span>
        )}
      </Meta>
    </Card>
  );
}

const Card = styled.article`
  padding: 1rem;
  border-radius: 16px;
  background: #202a43;
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

const TopLine = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
`;

const Title = styled.strong`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  font-weight: 950;
`;

const Description = styled.small`
  display: block;
  margin-top: 0.25rem;
  opacity: 0.7;
`;

const SourceBadge = styled.span`
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  background: rgba(90, 180, 120, 0.18);
  color: #9ff0b9;
  font-size: 0.7rem;
  font-weight: 950;
`;

const AmountBadge = styled.span`
  height: fit-content;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  background: #fff9ea;
  color: #0b1328;
  font-size: 0.75rem;
  font-weight: 950;
  white-space: nowrap;
`;

const Meta = styled.div`
  display: grid;
  gap: 0.35rem;
  margin-top: 0.9rem;
  font-size: 0.9rem;
  opacity: 0.82;
`;
